import React, { useState } from 'react';
import { Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePW1313Query } from './hooks/usePW1313Query';
import QueryParamsPanel from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryParams } from '../../services/pw1313Api';
import './PW1313Form.css';

const PW1313Form: React.FC = () => {
  const { loading, data, queried, noData, runQuery, reset } = usePW1313Query();
  const [productFrom, setProductFrom] = useState('');
  const [productTo, setProductTo] = useState('');

  const handleQuery = () => {
    const params: QueryParams = {
      productFrom: productFrom.trim() || undefined,
      productTo: productTo.trim() || undefined,
    };
    runQuery(params);
  };

  const handleReset = () => { setProductFrom(''); setProductTo(''); reset(); };

  const handlePrint = () => {
    if (!data || data.length === 0) return;
    const win = window.open('', '_blank');
    if (!win) return;
    const now = new Date().toLocaleString('zh-TW');
    win.document.write(`<!DOCTYPE html><html><head><title>產品清冊</title>
<style>body{font-family:'Microsoft JhengHei',sans-serif;margin:20px;font-size:12px;}
h2{text-align:center;}table{width:100%;border-collapse:collapse;}th,td{border:1px solid #333;padding:4px 8px;}
th{background:#f0f0f0;text-align:center;}@media print{body{margin:10mm;}}</style></head><body>
<h2>產品清冊</h2><div style="text-align:center;font-size:11px;color:#555;margin-bottom:12px;">列印時間: ${now}</div>
<table><thead><tr><th>品號前段</th><th>品號後段</th><th>類型</th><th>規格</th></tr></thead><tbody>
${data.map(r => `<tr><td>${r.code_front}</td><td>${r.code_back}</td><td style="text-align:center">${r.category}</td><td>${r.spec}</td></tr>`).join('')}
</tbody></table></body></html>`);
    win.document.close(); win.focus(); win.print();
  };

  return (
    <PermissionGuard module={Modules.PW1313} action="query">
      <div className="pw1313-container">
        <div className="pw1313-header">
          <h2>產品清冊</h2>
          <div className="pw1313-print-btn">
            {queried && !noData && <Button icon={<PrinterOutlined />} onClick={handlePrint}>列印</Button>}
          </div>
        </div>
        <QueryParamsPanel productFrom={productFrom} productTo={productTo} loading={loading}
          onProductFromChange={setProductFrom} onProductToChange={setProductTo}
          onQuery={handleQuery} onReset={handleReset} />
        <ResultTable data={data} loading={loading} queried={queried} noData={noData} />
      </div>
    </PermissionGuard>
  );
};

export default PW1313Form;
